import {
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { SubSink } from 'subsink';
import { Unity4Claim } from '../models';
import { AuthService } from '../services';

@Directive({
  selector: '[libHasClaim]',
})
export class HasClaimDirective implements OnDestroy {
  private subs = new SubSink();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  @Input() set libHasClaim(claim: Unity4Claim | Unity4Claim[]) {
    //const _claims: Unity4Claim[] = Array.isArray(claim) ? [...claim] : [claim];
    this.subs.sink = this.authService.hasClaim$(claim).subscribe((hasClaim) => {
      // Remove any existing template from DOM
      this.viewContainer.clear();
      if (hasClaim) {
        // Add template to DOM
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }
}
